export enum UscgPortStatus {
    OPEN = 1,
    RESTRICTED = 2,
    CLOSED = 3,
}
